var ecoFeeProductTypes = ["Paint", "Interior Paint", "Exterior Paint", "Stain", "Exterior Stain", "Primer", "Specialty", "Color"];
var ecoFeeProductObject = {};
var currentEcoFees = {};
var ecoFeeProductVariants = {};

String('1 Pint Sample, Pint').split(',').map(item => item.trim()).forEach(function(variantName) {
    ecoFeeProductVariants[variantName] = 35867443069090;
});
String('Quart').split(',').map(item => item.trim()).forEach(function(variantName) {
    ecoFeeProductVariants[variantName] = 35867443069090;
});
String('Gallon').split(',').map(item => item.trim()).forEach(function(variantName) {
    ecoFeeProductVariants[variantName] = 35867443101858;
});
String('2 Gallon, 5 Gallon').split(',').map(item => item.trim()).forEach(function(variantName) {
    ecoFeeProductVariants[variantName] = 35867443134626;
});

$(document).ready(function() {

    theme.onCartUpdate = function() {
        ecoFeeProductObject = {};
        currentEcoFees = {};
        $.getJSON('/cart.js', function(cart) {
            for (ecoFeeProductVariant in ecoFeeProductVariants) {
                ecoFeeProductObject[ecoFeeProductVariants[ecoFeeProductVariant]] = 0;
                currentEcoFees[ecoFeeProductVariants[ecoFeeProductVariant]] = 0;
            }
            cart.items.forEach(function(item) {
                if (Object.values(ecoFeeProductVariants).includes(item.variant_id)) {
                    currentEcoFees[item.variant_id] = item.quantity;
                }
                if (ecoFeeProductTypes.includes(item.product_type)) {
                    item.options_with_values.forEach(function(option) {
                        if (option.name == 'Size' || option.name == 'Sample') {
                            if (option.value in ecoFeeProductVariants) {
                                ecoFeeProductObject[ecoFeeProductVariants[option.value]] += item.quantity;
                            }
                        }
                    });
                }
            });

            var updateRequired = false;
            for (currentEcoFee in currentEcoFees) {
                if (ecoFeeProductObject[currentEcoFee] !== currentEcoFees[currentEcoFee]) {
                    updateRequired = true;
                }
            }

            if (updateRequired) {
                data = {
                    'updates': ecoFeeProductObject
                }
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: data,
                    dataType: 'json',
                    success: function() {                        
                        theme.updateCartOutput();
                    }
                });
            } else {
                theme.updateCartOutput();
            }
        });
    };

    theme.updateCartOutput = function() {
        setTimeout(function(){
            var feeTotal = 0;
            var feeTitle = '';
            var ecoFeeQuantity = 0;
            $.getJSON('/cart.js', function(cart) {
                cart.items.forEach(function(item) {
                    if(item.product_type == 'Fee') {
                        feeTotal += (item.price*item.quantity);
                        feeTitle = item.product_title;
                    }
                    if (Object.values(ecoFeeProductVariants).includes(item.variant_id)) {
                        ecoFeeQuantity += item.quantity;
                    }
                });
                $('.Drawer__Footer .Cart__Fees').text(feeTitle + ' ' + Shopify.formatMoney(feeTotal, theme.moneyFormat));
                $('.Header__CartCount').text(cart.item_count - ecoFeeQuantity);
            });
        }, 500);
    };

    theme.onCartUpdate();

});


